module.exports = __webpack_public_path__ + "b5f06f846f97e3542c22be1834fd096c.pdf";